import { render, staticRenderFns } from "./wtt.vue?vue&type=template&id=70d548a7&scoped=true&"
import script from "./wtt.vue?vue&type=script&lang=js&"
export * from "./wtt.vue?vue&type=script&lang=js&"
import style0 from "./wtt.vue?vue&type=style&index=0&id=70d548a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d548a7",
  null
  
)

export default component.exports